import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../service/auth.service";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {AppMessageService} from "../../service/app-message.service";
import {MessageHelper} from "../../helper/message-helper";

@Component({
  selector: 'login-with-token',
  templateUrl: './login-with-token.component.html'
})
export class LoginWithTokenComponent implements OnInit, OnDestroy{

  busy: boolean = false;  // indicator whether the component is busy
  initialized: boolean = false; // indicator whether the component was initialized
  loginErrorMessage: string | null = null;


  constructor(
    protected authService: AuthService,
    protected userApiService: UserApiService,
    protected messageService: AppMessageService,
    protected router: Router,
    protected route: ActivatedRoute) {
  }

  ngOnInit() {
    this.initComponent();
  }

  initComponent() {

    this.route.queryParamMap.subscribe(params => {
      const passCode = params.get('logon_token');
      if (passCode) {
        this.handleLogin(passCode);
      }else {
        this.loginErrorMessage = 'token not provided';
      }
    });

    this.refreshComponent();
  }

  refreshComponent() {
    this.initialized = true;
  }

  handleLogin(passCode: string) {

    if (this.busy) {
      return;
    }

    this.busy = true;

    this.authService.loginPassCode(passCode).subscribe(value => {

      this.busy = false;
      this.router.navigate(["/ext_mycontracts"]);

    }, error => {
      // this.messageService.showErrorMessage("", "Email oder Passwort sind falsch. Bitte erneut eingeben!");
      MessageHelper.showErrorMessage("Email oder Passwort sind falsch. Bitte erneut eingeben!", this.messageService);
      this.loginErrorMessage = 'Einmal-Code ist ungültig oder abgelaufen.';
      this.busy = false;
      this.router.navigate(["/login"]);
    });

  }

  ngOnDestroy() {
  }

}
